<template>
    <div class="Info">
        <Header :title="article.title"></Header>
        <van-empty description="" v-if="!article" />
        <div>
            <h3 class="toptext">{{title}}</h3>
        </div>
        <div v-html="content" class="content"></div>
        <Bottom_comp></Bottom_comp>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import Footer from '@/components/Footer.vue'
    import Bottom_comp from "../components/Bottom_comp";

    export default {
        name: "Information",
        data(){
            return {

                article:{},
                title:"",
                content:"",
            }
        },
        mounted(){
            this.getInfoData();
        },
        methods:{
            getInfoData(){
                this.getReq('/getInfoData',{
                    name:this.$route.query.name
                }).then((res)=>{
                    if(res.code==200){
                        let lang = window.localStorage.getItem('lang')
                        this.article = res.data;
                        if(lang=='cn'){
                          this.title=this.article.title_cn
                          this.content =this.article.content_cn
                        }else if(lang=='en'){
                          this.title=this.article.title_en
                          this.content =this.article.content_en
                        }else if(lang=='de'){
                          this.title=this.article.title_de
                          this.content =this.article.content_de
                        }
                    }
                })
            }
        },
        components:{
            Bottom_comp,
            Header,
            Footer

        }
    }
</script>

<style scoped lang="scss">
  .Info{
    min-height: 800px;
    background: #ffffff;
    .toptext{
      margin-top: 20px;
      font-size: 25px;
      font-weight: bold;
    }
    .content{
      text-align: left;
      padding: 10px;
    }

  }

</style>
